import Layout from "../../components/Layout/Layout";

const EMAIL = "rencamp@earthboundmartian.com";

const Contact = () => {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-16 w-full">
        <p className="text-sun font-semibold uppercase tracking-wide text-sm">
          RenCamp
        </p>
        <h1 className="text-5xl font-bold text-alt-blk mt-3">Contact</h1>
        <p className="text-xl text-alt-blk/80 mt-6 leading-relaxed">
          Date corrections, camping notes, and “this faire should be on the map”
          messages are welcome. Write to{" "}
          <a
            href={`mailto:${EMAIL}`}
            className="text-turquoise hover:text-mars break-all"
          >
            {EMAIL}
          </a>
          .
        </p>
        <p className="leading-relaxed mt-6">
          v1 has no user accounts. If you know a renaissance, historical, fairy,
          mermaid, or pirate gathering that is worth planning a trip around —
          especially in Canada, Alaska, or anywhere you can actually camp —
          tell us what the overnight situation actually is.
        </p>
        <a
          href={`mailto:${EMAIL}`}
          className="inline-block mt-10 bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold"
        >
          Email RenCamp
        </a>
      </section>
    </Layout>
  );
};

export default Contact;
